/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useWorkFlow, LOCK_BUTTON, UPDATE_CAPTCHA, UPDATE_USER } from "../../contexts/workflow";
import { _translate, _Notifications } from "../../../services/core";
import { _Captcha as Captcha } from "../../core/common";
var Index = function Index() {
  // Utilisation du context pour récupérer le diag et la communauté attachée.
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    dispatcher = _useWorkFlow.dispatcher;
  var generateAnonymousEmail = function generateAnonymousEmail() {
    var username = "anonymous_".concat(Date.now(), "@wever.fr");
    dispatcher({
      type: UPDATE_USER,
      value: username
    });
  };
  var handleCaptchaSuccess = function handleCaptchaSuccess(token, key) {
    dispatcher({
      type: UPDATE_CAPTCHA,
      value: {
        token: token,
        key: key
      }
    });
    generateAnonymousEmail();
    dispatcher({
      type: LOCK_BUTTON,
      value: false
    });
  };
  var handleCaptchaFailure = function handleCaptchaFailure() {
    _Notifications.warning(_translate('collectorapp_captcha_title'), _translate('collectorapp_captcha_failed'));
    dispatcher({
      type: UPDATE_CAPTCHA,
      value: null
    });
  };
  useEffect(function () {
    if (!collector && !collector.diag) {
      return;
    }
    dispatcher({
      type: LOCK_BUTTON,
      value: true
    });
  }, []);
  return /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-center collectorConnectContainer"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "6"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Captcha, {
    number: "6",
    onSuccess: handleCaptchaSuccess,
    onFailure: handleCaptchaFailure
  }))));
};
export default Index;